import React, { useState, useRef, useEffect } from 'react'
import { FilePreview } from '@ow/comps'
import {
  useDitto,
  checkIsImage,
  getWatermarkUrl,
  checkFile,
  getType,
} from '@ow/ditto-core'
import { fileTypeImg } from '../../utils/file-constants'

const showMediaType = ['image', 'video', 'audio']
const MediaItem = ({ files, url = '', item, rowData, defs, index, hooks }) => {
  const [tbDataIndex, setTbDataIndex] = useState(null)
  const _tbDataIndex = useRef(tbDataIndex)
  const [allFiles, setAllFiles] = useState(files || [])
  const { addWatermarkToImage } = useDitto()
  const { filename, fileType } = item
  const extension = fileType || checkFile(url)
  const { key } = getType(extension)
  const allFilesRef = useRef(files)

  let src = url
  const position = url.indexOf('?Expires=') // 对非表单新建的数据特殊处理
  if (url.indexOf('ow-prod.oss-') > -1 || url.indexOf('ow-prod-cdn') > -1) {
    src = `${
      position === -1 ? url : url.slice(0, position)
    }?x-oss-process=image/resize,h_170,m_lfit`
  }

  const switchNextDataMedia = () => {
    if (hooks && hooks.beforeTransform && hooks.switchDataNextOrPrev) {
      const mediaData = hooks.switchDataNextOrPrev(
        rowData,
        _tbDataIndex.current,
        setTbDataIndex
      )
      if (mediaData) {
        const finalValue =
          hooks.beforeTransform(mediaData[defs.slug], defs, mediaData) || []
        const arr = [...allFilesRef.current, ...finalValue]
        allFilesRef.current = arr
        setAllFiles(arr)
        // eslint-disable-next-line no-use-before-define
        onFilePreview(arr, arr.length - 1)
      }
    }
  }

  const onFilePreview = (arr, _index) => {
    FilePreview.preview(
      arr.map((v) => {
        const endPosition = url.indexOf('?Expires=')
        const isImage = checkIsImage(v)
        const link = v.src || v.link
        const originSrc = endPosition === -1 ? link : link.slice(0, endPosition)
        if (v.waterMarkInfo) {
          const { originWatermarkUrl, thumbnailWatermarkUrl } = getWatermarkUrl(
            { originSrc, ...v },
            addWatermarkToImage,
            v.waterMarkInfo
          )
          return {
            ...v,
            data: rowData,
            src: originSrc,
            srcWatermark: isImage ? thumbnailWatermarkUrl : src,
            originWatermarkUrl,
            switchNextDataMedia: hooks?.switchDataNextOrPrev
              ? switchNextDataMedia
              : null,
          }
        }
        return {
          ...v,
          data: rowData,
          src: originSrc,
          srcWatermark: originSrc, // 冲突了，暂时保留闫俊的
          originWatermarkUrl: originSrc,
          switchNextDataMedia: hooks?.switchDataNextOrPrev
            ? switchNextDataMedia
            : null,
        }
      }),
      _index,
      true,
      (_files, currentFile, onCancle, indexx) => {
        if (hooks.updateMarkImg) {
          hooks
            .updateMarkImg(_files, currentFile, onCancle)
            .then((mediaData) => {
              const finalValue =
                hooks.beforeTransform(mediaData[defs.slug], defs, mediaData) ||
                []
              // 只判断了一个
              if (finalValue && finalValue.length) {
                const _arr = [...allFilesRef.current]
                _arr.splice(indexx, 1, finalValue[0])
                allFilesRef.current = _arr
                setAllFiles(_arr)
                onFilePreview(_arr, indexx)
              }
            })
        }
      },
      () => {
        setTbDataIndex(null)
      }
    )
  }

  useEffect(() => {
    _tbDataIndex.current = tbDataIndex
  }, [tbDataIndex])

  return (
    <div className="mr-2 flex w-auto float-left items-center">
      <div
        className="w-auto flex"
        onClick={() => {
          onFilePreview(
            allFiles.map((v) => {
              return { ...v, slug: defs.slug }
            }),
            index
          )
        }}
      >
        {showMediaType.includes(key) ? (
          <img
            src={
              key === 'image' ? src : fileTypeImg[extension] || fileTypeImg[key]
            }
            alt=""
            style={{ height: '28px', minHeight: '28px', maxHeight: '45px' }}
          />
        ) : (
          <div className="flex flex-row items-center w-auto h-full gap-2">
            <img
              className="rounded-box"
              src={fileTypeImg[extension] || fileTypeImg[key]}
              style={{
                width: '14.17px',
                height: '17px',
              }}
              alt=""
            />
            <span className="overflow-hidden text-ellipsis truncate">
              {filename}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

const Media = function ({ value, rowData, defs, hooks }) {
  return (
    <div className="w-full flex flex-wrap">
      {(value || []).map((item, index) => {
        const { src, link } = item || {}
        if ((src || link) && index < 3) {
          return (
            <MediaItem
              files={value || []}
              key={index}
              item={item}
              url={src || link}
              index={index}
              isClicked={false}
              rowData={rowData}
              hooks={hooks}
              defs={defs}
            />
          )
        }
        return null
      })}
    </div>
  )
}
export default Media
